// add permanents signal functionality
;(function permanentPhaserSignalIIFE() {

  if (!Phaser.Signal.prototype.addPermanent) {
    Phaser.Signal.prototype.addPermanent       = addPermanent;
    Phaser.Signal.prototype.removeNonPermanent = removeNonPermanent;
  }

  return;

  function addPermanent(/*arguments*/) {
    var signal = this;

    var signalBinding = signal.add.apply(signal, arguments);
    signalBinding._PERMANENT = true;
    return signalBinding;
  }

  function removeNonPermanent() {
    var signal = this;

    if (!signal._bindings) return;

    var n = signal._bindings.length;

    while (n--) {
      if (!signal._bindings[n]._PERMANENT) {
        signal._bindings[n]._destroy();
        signal._bindings.splice(n, 1);
      }
    }
  }

}());
